/**
 * Sorting helper for nullable bigint values
 * Undefined values are sorted to the bottom
 */
export const sortNullableBigInt = (a: bigint | undefined, b: bigint | undefined): number => {
  if (a === undefined && b === undefined) return 0;
  if (a === undefined) return 1;
  if (b === undefined) return -1;
  return a > b ? 1 : a < b ? -1 : 0;
};
